module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/event2_tvb-740cbef815ea664575772c5c51204e3f.jpg";